module.exports = __webpack_public_path__ + "static/media/enterprise-employers.8d28485a.jpg";